export const AirLineSeamless = ['DL','AF','KL','UX', 'AR', 'LA'];

export const AIRLINES = {
    "DL": "Delta Airlines",
    "AF": "Air France",
    "AS": "Alaska Airlines",
    "KL": "KLM",
    "SU": "Aeroflot",
    "AR": "Aero Lineas",
    "AZ": "Alitalia",
    "AV": "Avianca",
    "AB": "Avianca Brazil",
    "CI": "China Airlines",
    "MU": "China Eastern Airlines",
    "CZ": "China Southern Airlines",
    "OK": "Czech Airlines",
    "GA": "Garuda Airlines",
    "GO": "GOL Airlines",
    "KE": "Korean Air",
    "ME": "MEA",
    "SV": "Saudi Airlines",
    "VN": "Vietnam Airlines",
    "WS": "West Jet Airlines",
    "MF": "Xiamen Airlines",
    "AM": "Aeromexico",
    "UX": "Air Europa",
    "LA": 'LATAM',
}